import React from 'react';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import { IBestDataset, IPreviewData } from '../../../../../types/analytics';
import ScatterPlot from '../Plot/ScatterPlot/ScatterPlot';
import { TabKey } from '../../../../../utils/common';
import {IEnrichedMetadata} from "../../../../../types/metadata";

interface ScatterPlotBoxProps {
  activePlotAnalytics: string | null;
  scatterPlotPreview: IPreviewData | null;
  coordinates: number[];
  previewDatasetId: string;
  previewDatasetTimeRange: any;
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
  loadingScatterPlot: boolean;
  errorScatterPlot: string;
  categoryDataset: IBestDataset[];
  onDatasetChange: (value: string) => void;
  updatedScatterPlotData: any[];
  pointProps: string;
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (value: Partial<IAnalytcisUserInput>) => void;
  gridCellSize: string;
  waterDepth: string;
  handleChangePoint: (item: any, key?: TabKey) => void;
  pointOptions: { label: string; value: string }[];
  onUpdateScatterPlot: (values: any) => Promise<void>;
  onUpdateJointScatterPlot: (values: any) => Promise<void>;
  scatterPlotPreviewError: string
  enrichedMetadata: IEnrichedMetadata[]
  isOffline: boolean
}

const ScatterPlotBox: React.FC<ScatterPlotBoxProps> = ({
  activePlotAnalytics,
  scatterPlotPreview,
  coordinates,
  previewDatasetId,
  previewDatasetTimeRange,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  loadingScatterPlot,
  errorScatterPlot,
  categoryDataset,
  onDatasetChange,
  updatedScatterPlotData,
  pointProps,
  pointName,
  userInput,
  updateUserInput,
  gridCellSize,
  waterDepth,
  handleChangePoint,
  pointOptions,
  onUpdateScatterPlot,
  onUpdateJointScatterPlot,
  scatterPlotPreviewError,
  enrichedMetadata,
  isOffline,
}) => {
  if (activePlotAnalytics !== 'Scatter Plot') {
    return null;
  }

  return (
    <ScatterPlot
      coordinates={coordinates}
      previewDatasetId={previewDatasetId}
      previewDatasetTimeRange={previewDatasetTimeRange}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      updating={loadingScatterPlot}
      error={errorScatterPlot}
      categoryDataset={categoryDataset}
      onDatasetChange={onDatasetChange}
      defaultValueShortName={scatterPlotPreview?.DefaultValueShortName}
      defaultDirectionShortName={scatterPlotPreview?.DefaultDirectionShortName}
      variables={scatterPlotPreview?.ItemsInfo ?? []}
      dateRange={[ scatterPlotPreview?.StartDate ?? '', scatterPlotPreview?.EndDate ?? '' ]}
      tsData={scatterPlotPreview?.Data?.Items ?? []}
      previewError={scatterPlotPreviewError}
      enrichedMetadata={enrichedMetadata}
      onUpdateScatterPlot={onUpdateScatterPlot}
      updatedScatterPlotData={updatedScatterPlotData}
      onUpdateJointScatterPlot={onUpdateJointScatterPlot}
      pointProps={pointProps}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      gridCellSize={gridCellSize}
      waterDepth={waterDepth}
      onChangeActiveKey={handleChangePoint}
      pointOption={pointOptions}
      isOffline={isOffline}
    />
  );
};

export default ScatterPlotBox;
